export default "__VITE_ASSET__DGnrSfnj__"